export default __webpack_public_path__ + "static/media/explore-desktop-1.e11ee047.png";